/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-animation',['require','underscore','jquery','backbone','activities/scenario-activity','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var ScenarioActivity = require('activities/scenario-activity');
  var Engine = require('core/engine');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityAnimation = ScenarioActivity.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    el: '<div data-role="scenario-activity" class="scenario-activity">',
    template: _.template('<div data-role="activity-content" class="activity-content"></div>'),
    options: { },

    radio: Backbone.Wreqr.radio.channel('global').vent,
    suspended: false,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ScenarioActivity.prototype.initialize.apply(this, arguments);

      this.performance = 'good';

      //this.options = _.assign(this.options, this.model.get('options'));

      //this.setLayout();
      //this.setInterface();
      //this.activityReady();
    },

    begin: function()
    {
      $(document).on('activity.animation.channel', $.proxy(this.channelStarted, this));
      ScenarioActivity.prototype.begin.apply(this, arguments);
      //console.error('activity begin');
      $(document).trigger('activity.animation.start', Engine.module('Media'));
      $(document).on('activity.animation.complete', $.proxy(this.finish, this));
    },

    channelStarted: function(e, _channel)
    {
      ////console.log('channel started', e, _channel);
      this.channel = _channel;
      ////console.log(this.content);
      if (this.content.ContentAnimation && this.content.ContentAnimation[0] && this.content.ContentAnimation[0].line)
      {
        ////console.log('channel set caption from animation', this.content.ContentAnimation, this.content.ContentAnimation[0]);
        var _audioObj = this.content.ContentAnimation[0].line;
        var _audioArr = [];
        _.forEach(_audioObj, function(_line) {
          _audioArr.push({character: _line.character, caption: _line.text});
        });
        this.channel.setCaption(_audioArr);
      }
      $(document).off('activity.animation.channel');
    },

    onMediaEnded: function(e)
    {
      ////console.log('BaseScreen::onMediaEnded');
    },

    onBeforeDestroy: function()
    {
      $(document).off('activity.animation.complete');
      $(document).off('activity.animation.channel');
      ScenarioActivity.prototype.onBeforeDestroy.apply(this);
    },

    finish: function()
    {

      ScenarioActivity.prototype.finish.apply(this);
    }

  /*****************************************************************************************************************///}

  });

  return ActivityAnimation;

});

